require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-171-api-personal-access-tokens.json") })
        }
      }, "path---article-171-api-personal-access-tokens");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-171-api-personal-access-tokens!./.cache/json/article-171-api-personal-access-tokens.json
// module id = 520
// module chunks = 231608221292675